import * as VueGoogleMaps from "vue2-google-maps";

import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons, IconsPlugin } from "bootstrap-vue";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import App from './App';
import VueRouter from 'vue-router';
import store from './store';
import config from '@/common/config';
import { loadScriptsForCurrentSubdomain } from '@/common/subdomainTracking';

import AboutPage from '@/views/About';
import Tutorials from '@/views/Tutorials';
import AddAtractionsImage from '@/views/AddAtractionsImage.vue';
import AddAccommodationsImage from '@/views/AddAccommodationsImage.vue';
import AddAccommodationFromImage from '@/views/AddAccommodationFromImage.vue';
import AddAttractionFromImage from '@/views/AddAttractionFromImage.vue';
import TermsOfUse from '@/views/TermsOfUse';
import DeleteUser from '@/views/DeleteUser';
import PrivacyPolicy from '@/views/PrivacyPolicy';
import AuthHandler from './components/AuthHandler';
import HomePage from '@/views/HomePage';
import HomePageNew from '@/views/HomePageNew';
import RideAccommodation from '@/views/Accommodation';
import BookingDotCom from '@/views/BookingDotCom';
import SingleRideWithMap from '@/views/SingleRideWithMap';
import SingleRideWithMapAndAttraction from '@/views/SingleRideWithMapAndAttraction';
import SingleMapWithAllSearchOnMap from '@/views/SingleMapWithAllSearchOnMap';
import FullScreenSingleRideMap from '@/views/FullScreenSingleRideMap';
import RideChecklist from '@/views/RideChecklist';
import SerchAttractionsWithMap from '@/views/SerchAttractionsWithMap';
import RideManagerAttractions from '@/views/RideManagerAttractions';
import EditingAtractionsUniqnes from '@/views/EditingAtractionsUniqnes';
import SearchRide from '@/views/SearchRide';
import SearchAccommodationWithMap from '@/views/SearchAccommodationWithMap';
import RideAttraction from '@/views/Attraction';
import OfflineRideRecovery from '@/views/OfflineRideRecovery';
import AttractionEditing from '@/views/AttractionEditing';
import RideInformations from '@/views/RideInformation';
import ExtraInformationForRide from '@/views/ExtraInformationForRide';
import EditProfile from '@/views/EditProfile';
import AssignToRide from '@/views/AssignToRide';
import BlockedAccess from '@/views/BlockedAccess';
import PrivatePageLanding from '@/views/PrivatePageLanding';
import UserRidesV from '@/views/UserRides';
import UploadForm from './components/UploadForm';
import SingleRide from './components/SingleRide';
import SingleRideMap from './components/SingleRideMap';
import GlobalMap from './components/GlobalMap';
import InsertNewRideFromGooglePhotos from '@/views/InsertNewRideFromGooglePhotos';
import SerchAttractions from './components/SerchAttractions';
import CreateAttraction from './components/CreateAttraction';
import UserRides from './components/UserRides';
import RideInformation from './components/RideInformation';
import EditRideAccessKey from './views/EditRideAccessKey';
import GeneratOneTimeAccessKey from './views/GeneratOneTimeAccessKey';
import LoadScript from 'vue-plugin-load-script';
import GlobalRides from './components/GlobalRides';
import PagePopups from './components/Popups';
import CategoryManagement from '@/views/CategoryManagement';
import DeviceManagement from '@/views/DeviceManagement';
import ResetPasswordPage from '@/views/ResetPasswordPage';
import RequestPasswordReset from '@/views/RequestPasswordReset';
import RideManagerBilling from '@/views/RideManagerBilling';
import AdminMonthlySummary from '@/views/AdminMonthlySummary';
import AdminCustomerPricing from '@/views/AdminCustomerPricing';
import AdminDashboard from '@/views/AdminDashboard';
import OneTimeAccessUsage from '@/views/OneTimeAccessUsage';
import LandingForPlanners from '@/views/LandingForPlanners';
import LandingForPlannersNoFlight from '@/views/LandingForPlannersNoFlight';
import StoreForPlanners from '@/views/StoreForPlanners.vue';
import AdminManualLogin from '@/views/AdminManualLogin.vue';
import AdminBlockUser from '@/views/AdminBlockUser.vue';
import WhatsappTestPage from '@/views/WhatsappTestPage.vue';
import WhatsappLogin from '@/views/WhatsappLogin.vue';
import AdminWhatsappConversations from '@/views/AdminWhatsappConversations.vue';
import AdminSharedPlaceImages from '@/views/AdminSharedPlaceImages.vue';
import AdminAccommodationLinks from '@/views/AdminAccommodationLinks.vue';
import AdminRideAccommodationLinks from '@/views/AdminRideAccommodationLinks.vue';
import PaymentPage from '@/views/PaymentPage.vue';
import PaymentSuccess from '@/views/PaymentSuccess.vue';
import FeaturedRidesLanding from '@/views/FeaturedRidesLanding.vue';
import FeaturedRideDetail from '@/views/FeaturedRideDetail.vue';
import DigitalGuideInfo from '@/views/DigitalGuideInfo.vue';
import PrivateConsultingInfo from '@/views/PrivateConsultingInfo.vue';
import SpiritPage from '@/views/SpiritPage.vue';
import PricingPlans from '@/views/PricingPlans.vue';
import NewUserWelcome from '@/views/NewUserWelcome.vue';
import ReferralPage from '@/views/ReferralPage.vue';
import StartInsertRide from '@/views/StartInsertRide.vue';
import AfterFirstRide from '@/views/AfterFirstRide.vue';
import AfterFirstAttraction from '@/views/AfterFirstAttraction.vue';
import AgreementSignPage from '@/views/AgreementSignPage.vue';
import MonthlyBillingCardSetup from '@/views/MonthlyBillingCardSetup.vue';
import ImportRideDocuments from './views/ImportRideDocuments';
import GenerateRideWithAi from './views/GenerateRideWithAi';

// import '@babel/polyfill'
// import 'mutationobserver-shim'
import VueSocialSharing from 'vue-social-sharing'
import VueTextareaAutosize from 'vue-textarea-autosize';
import firebase from 'firebase/app';
import 'firebase/auth';

import VideoBackground from 'vue-responsive-video-background-player'
// import VueMeta from 'vue-meta'
import VueMeta from 'vue-meta'

Vue.component('video-background', VideoBackground);



var firebaseConfig = {
  apiKey: config.config.FIRE_BASE_API_KEY,
  authDomain: "tripplanner-308b3.firebaseapp.com",
  projectId: "tripplanner-308b3",
  storageBucket: "tripplanner-308b3.appspot.com",
  messagingSenderId: "869000350964",
  appId: "1:869000350964:web:4afb57434764563e1ee2a1",
  measurementId: "G-2LETZP7VRD"
};

// Load any subdomain-specific scripts as early as possible
loadScriptsForCurrentSubdomain(config.config.SUBDOMAIN_TRACKING || {});

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    try {
      navigator.serviceWorker
        .register('/sw.js')
        .then(() => {
          // ServiceWorker registered successfully
        })
        .catch(() => {
          // ServiceWorker registration failed
        });
    }
    catch (e) {
      // Unexpected error during registration
    }    
  });
}
else {
  // Service workers are not supported in this browser
}

window.addEventListener('offline', () => {
  // Save current scroll position before going offline
  localStorage.setItem('scrollPositionBeforeOffline', window.scrollY);
  
  const rideId = localStorage.getItem('lastRideId');
  if (rideId && window.location.pathname !== '/offline_ride_view') {
    // Check if service worker is controlling the page (preferred)
    // OR if we have cached ride data in localStorage (fallback)
    // The OfflineRideRecovery component loads from localStorage, so it can work without SW
    const hasServiceWorkerController = 'serviceWorker' in navigator && 
      navigator.serviceWorker.controller;
    const hasCachedData = localStorage.getItem('lastRideData');
    
    // Redirect if service worker is active OR we have cached data to display
    // The service worker is preferred because it can serve the full app, but
    // localStorage fallback ensures we can still show cached ride data
    if (hasServiceWorkerController || hasCachedData) {
      window.location.href = `/offline_ride_view`;
    }
  }
});

// Global online event listener to ensure we catch internet restoration
// On mobile, the online event may fire multiple times or be delayed, so we add a small delay
window.addEventListener('online', () => {
  // Use setTimeout to ensure the event is fully processed and network is actually available
  setTimeout(() => {
    // Double-check we're actually online (mobile browsers sometimes fire online event prematurely)
    if (!navigator.onLine) {
      return;
    }
    
    // Check if we're currently on the offline view
    if (window.location.pathname === '/offline_ride_view') {
      const rideId = localStorage.getItem('lastRideId');
      if (rideId) {
        // Save scroll position before redirecting back to main page
        const savedPosition = localStorage.getItem('scrollPositionBeforeOffline');
        if (savedPosition !== null) {
          localStorage.setItem('scrollPositionToRestore', savedPosition);
          localStorage.removeItem('scrollPositionBeforeOffline');
        }
        // Use replace instead of href to avoid adding to history
        window.location.replace(`/single_ride_with_map/${rideId}`);
      }
    }
  }, 500); // Small delay to ensure network is actually available
});

// workaround to forward user to the ride they loaded when installing the app
const rideId = localStorage.getItem('lastRideId');
const redirectPath = '/single_ride_with_map/' + rideId;
if ( window.location.pathname === '/redirect_to_cached_ride_if_exists' ) {
  if( rideId ){
    window.location.replace(redirectPath); // Redirects to the ride page
  }
  else{
    window.location.replace('/'); // Redirects to home page
  }
}

Vue.use(BootstrapVue);
Vue.use(IconsPlugin)
Vue.use(BootstrapVueIcons);
Vue.use(VueSocialSharing);
Vue.use(VueTextareaAutosize);
Vue.config.productionTip = false
// Vue.use(LoaderPlugin, {
//   client_id: '80587839075-a34ut0489s6kljp5rtn5c8t45qqcacmc.apps.googleusercontent.com'
// });



Vue.use(VueMeta)
Vue.use(VueRouter);
// Vue.use(VueMeta)
Vue.use(LoadScript);
const singleRideName = 'single ride with map with id'
export const router = new VueRouter({
  mode: 'history',
  routes: [
    { name: 'ride-manager-home', path: '/manager-home', component: NewUserWelcome },
    { name: 'new-user-welcome', path: '/welcome-ride-managers', component: NewUserWelcome },
    { name: 'english-home', path: '/home', component: HomePageNew },
    { name: 'referral-page', path: '/my-referral-link', component: ReferralPage },
    { name: 'start-insert-ride', path: '/start-insert-ride', component: StartInsertRide },
    { name: 'after-first-ride', path: '/after-first-ride/:rideId', component: AfterFirstRide },
    { name: 'after-first-attraction', path: '/after-first-attraction/:rideId', component: AfterFirstAttraction },
    { name: 'HomePage',path: '/', component: HomePageNew },
    { name: 'oldHomePage',path: '/old', component: HomePage },
    { name: 'about',path: '/about', component: AboutPage },
    { name: 'tutorials',path: '/tutorials', component: Tutorials },
    { name: 'addImages',path: '/add_images', component: AddAtractionsImage },
    { name: 'addImagesToThTrip',path: '/add_images/:ride_id', component: AddAtractionsImage },
    { name: 'addAttractionFromImage',path: '/add_attraction', component: AddAttractionFromImage },
    { name: 'AddAccommodationsImage',path: '/add_accommodations_image', component: AddAccommodationsImage },
    { name: 'AddAccommodationsImageToThTrip',path: '/add_accommodations_image/:ride_id', component: AddAccommodationsImage },
    { name: 'AddAccommodationFromImage',path: '/add_accommodation_from_image', component: AddAccommodationFromImage },
    { name: 'terms of use',path: '/terms_of_use', component: TermsOfUse },
    { name: 'privacy policy',path: '/privacy_policy', component: PrivacyPolicy },
    { name: 'delete user',path: '/delete_user', component: DeleteUser },
    { name: 'upload',path: '/upload', component: UploadForm },
    { name: 'oauth2callback',path: '/oauth2/callback', component: AuthHandler },
    { name: 'single_ride',path: '/single_ride', component: SingleRide },
    { name: 'single ride map',path: '/single_Ride_map', component: SingleRideMap },
    { name: 'single ride with map',path: '/single_ride_with_map', component: SingleRideWithMap },
    { name:  singleRideName ,path: '/single_ride_with_map/:id', component: SingleRideWithMap },
    { name: 'singleMapWithAllSearchOnMap' ,path: '/single_map_with_all_search_on_map', component: SingleMapWithAllSearchOnMap },
    { name: 'fullScreenSingleRideMap',path: '/full_screen_single_ride_map/:id/:dayId', component: FullScreenSingleRideMap },
    { name: "singleRidewithMapAndAtraction" ,path: '/single_ride_with_map_attraction/:id/:attractionId', component: SingleRideWithMapAndAttraction },
    { name: 'editing atractions uniqnes',path: '/editing_atractions_uniqnes', component: EditingAtractionsUniqnes },
    { name: 'ride checklist',path: '/ride_checklist', component: RideChecklist },
    { name: 'ride checklist with id',path: '/ride_checklist/:id', component: RideChecklist },
    // We should remove the global rides
    { name: 'global rides',path: '/global_rides', component: GlobalRides },
    //can we remove this?
    { name: 'global map',path: '/global_map', component: GlobalMap },
    // { name: 'insert new ride from google photos by id',path: '/insert_new_ride_from_google_photos/:ride_id', component: InsertNewRideFromGooglePhotos },
    { name: 'insert new ride from google photos',path: '/insert_new_ride_from_google_photos', component: InsertNewRideFromGooglePhotos },
    { name: 'serch attraction',path: '/serch_attractions', component: SerchAttractions },
    { name: 'search attraction with map',path: '/serch_attractions_with_map', component: SerchAttractionsWithMap },
    { name: 'ride mnager attraction',path: '/ride_manager_attraction', component: RideManagerAttractions },
    { name: 'search ride',path: '/search_ride', component: SearchRide },
    { name: config.config.ROUTES_URL_NAMES.searchRideByName ,path: '/search_ride_by_name/:location_name', component: SearchRide },
    { name: 'search accommodations from ride' ,path: '/search_accommodations', component: SearchAccommodationWithMap },
    { name: config.config.ROUTES_URL_NAMES.searchAccommodationsNyName,path: '/search_accommodations_by_name/:location_name', component: SearchAccommodationWithMap },
    { name: 'add new attraction to ride',path: '/add_new_attraction_to_ride_old', component: CreateAttraction },
    { name: 'attraction editing',path: '/add_new_attraction_to_ride', component: AttractionEditing },
    { name: 'attraction',path: '/attraction', component: RideAttraction },
    { name: 'attractionInforation',path: '/attractionInformation', component: RideAttraction },
    { name: 'accommodation',path: '/accommodation', component: RideAccommodation },
    { name: 'booking dot com',path: '/booking', component: BookingDotCom },
    // We should remove all the old part!!!!!!!!!!!!!
    { name: 'user rides old',path: '/user_rides_old', component: UserRides },
    { name: 'user rides',path: '/user_rides', component: UserRidesV },
    { name: 'the old ride information',path: '/ride_information_old', component: RideInformation },
    { name: 'ride information',path: '/ride_information', component: RideInformations },
    { name: 'admin manual login', path: '/admin/manual-login', component: AdminManualLogin },
    { name: 'admin_block_user', path: '/admin/block-user', component: AdminBlockUser, meta: { requiresAuth: true, requiresManager: true } },
    // Throwaway admin harness for the WhatsApp Cloud API. Intentionally not linked
    // from the navbar; the backend also refuses unless WHATSAPP_TEST_ENABLED is set.
    // adminOnly, not the meta flags beside it: nothing in this app reads
    // to.meta, so requiresManager blocks nobody. This page can send real
    // WhatsApp messages, so it gets a guard that actually runs.
    { name: 'whatsapp_test', path: '/whatsapp_test', component: WhatsappTestPage, beforeEnter: adminOnly, meta: { requiresAuth: true, requiresManager: true } },
    // No requiresAuth: this route's purpose is to log the traveller in.
    { name: 'whatsapp_login', path: '/wa_login/:token', component: WhatsappLogin },
    { name: 'ride extra information',path: '/ride_extra_information/:ride_id', component: ExtraInformationForRide },
    { name: 'edit profile',path: '/edit_profile', component: EditProfile, meta: {
                                                                                                  requiresAuth: true,
                                                                                                  requiresManager: true
                                                                                                }
    },
    { name: 'ride access key information',path: '/ride_access_key_information/:ride_key', component: EditRideAccessKey },
    { name: 'generate one ride access key',path: '/generate_one_ride_access_key/:ride_id', component: GeneratOneTimeAccessKey },
    { path: '/blocked', component: BlockedAccess },
    { name: 'assign to ride with key',path: '/assign_to_ride', component: AssignToRide },
    { name: 'assign to ride',path: '/assign_to_ride/:ride_key', component: AssignToRide, props: { context: 'standalone' } },
    { name: 'assign to ride with consulting',path: '/assign_to_ride_with_consulting/:ride_key', component: AssignToRide, props: { context: 'consulting' } },
    { name: 'private page landing',path: '/private_page_landing/:ride_id', component: PrivatePageLanding },
    { name: 'offline ride view',path: '/offline_ride_view', component: OfflineRideRecovery },
    { name: 'popups',path: '/popups', component: PagePopups },
    { name: 'admin_categories',path: '/admin/categories', component: CategoryManagement, meta: {
                                                                                                  requiresAuth: true,
                                                                                                  requiresManager: true
                                                                                                }
    },
    { name: 'device_management',path: '/admin/device_management', component: DeviceManagement, beforeEnter: adminOnly, meta: {
                                                                                                  requiresAuth: true,
                                                                                                  requiresManager: true
                                                                                                }
    },
    { name: 'ride_manager_billing',path: '/admin/ride_manager_billing', component: RideManagerBilling, meta: {
                                                                                                  requiresAuth: true,
                                                                                                  requiresManager: true
                                                                                                }
    },
    { name: 'admin_monthly_billing_summary', path: '/admin/monthly_billing_summary', component: AdminMonthlySummary, meta: {
                                                                                                  requiresAuth: true,
                                                                                                  requiresManager: true
                                                                                                }
    },
    { name: 'admin_customer_pricing', path: '/admin/customer-pricing', component: AdminCustomerPricing, meta: {
                                                                                                  requiresAuth: true,
                                                                                                  requiresManager: true
                                                                                                }
    },
    { name: 'admin_dashboard', path: '/admin', component: AdminDashboard, meta: {
                                                                                                  requiresAuth: true,
                                                                                                  requiresManager: true
                                                                                                }
    },
    { name: 'one_time_access_usage',path: '/admin/one_time_access_usage', component: OneTimeAccessUsage, meta: {
                                                                                                  requiresAuth: true,
                                                                                                  requiresManager: true
                                                                                                }
    },
    { name: 'admin_whatsapp_conversations', path: '/admin/whatsapp-conversations', component: AdminWhatsappConversations, beforeEnter: adminOnly, meta: {
                                                                                                  requiresAuth: true,
                                                                                                  requiresManager: true
                                                                                                }
    },
    { name: 'admin_shared_place_images', path: '/admin/shared-place-images', component: AdminSharedPlaceImages, beforeEnter: adminOnly, meta: {
                                                                                                  requiresAuth: true,
                                                                                                  requiresManager: true
                                                                                                }
    },
    { name: 'admin_accommodation_links', path: '/admin/accommodation-links', component: AdminAccommodationLinks, meta: {
                                                                                                  requiresAuth: true,
                                                                                                  requiresManager: true
                                                                                                }
    },
    { name: 'admin_ride_accommodation_links', path: '/admin/ride-accommodation-links', component: AdminRideAccommodationLinks, meta: {
                                                                                                  requiresAuth: true,
                                                                                                  requiresManager: true
                                                                                                }
    },
    { name: 'import_ride_documents', path: '/import-ride-documents', component: ImportRideDocuments, meta: { requiresAuth: true, requiresManager: true } },
    { name: 'generate_ride_with_ai', path: '/generate-ride-with-ai', component: GenerateRideWithAi, beforeEnter: adminOnly, meta: { requiresAuth: true, requiresManager: true } },
    { name: 'reset-password', path: '/reset-password', component: ResetPasswordPage },
    { name: 'request-password-reset', path: '/request-password-reset', component: RequestPasswordReset },
    { name: 'landing-for-planners', path: '/for-planners', component: LandingForPlanners },
    { name: 'landing-for-planners-no-flight', path: '/for-planners-no-flight', component: LandingForPlannersNoFlight },
    { name: 'store-for-planners', path: '/store-for-planners', component: StoreForPlanners },
    { name: 'payment', path: '/payment', component: PaymentPage },
    { name: 'monthly_billing_card_setup', path: '/billing/monthly_card_setup', component: MonthlyBillingCardSetup, meta: {
      requiresAuth: true,
    } },
    { name: 'payment-success', path: '/payment-success', component: PaymentSuccess },
    { name: 'featured-rides-landing', path: '/featured-rides', component: FeaturedRidesLanding },
    { name: 'featured-rides-landing-manager', path: '/featured-rides/:managerUrlName', component: FeaturedRidesLanding },
    { name: 'featured-ride-detail', path: '/featured-ride-detail/:id', component: FeaturedRideDetail },
    { name: 'digital-guide-info', path: '/digital-guide-info', component: DigitalGuideInfo },
    { name: 'private-consulting-info', path: '/private-consulting-info', component: PrivateConsultingInfo },
    { name: 'spirit-page', path: '/spirit', component: SpiritPage },
    { path: '/payment-how-it-works', redirect: '/pricing' },
    { name: 'pricing-plans', path: '/pricing', component: PricingPlans },
    { name: 'sign-agreement', path: '/sign_agreement', component: AgreementSignPage },
  ],
  /* eslint-disable no-unused-vars */
  scrollBehavior( to, _from, _savedPosition ) {
    if ( to.name == singleRideName ){
      var reload = parseInt( localStorage.getItem('workAroundToSetTheScroleLocationAtTheMAinPage') );
      return {x: 0 , y: reload }
    }
    return {x: 0, y: 0}
  }
});
// from faceBook url: https://localhost:1024/single_ride_with_map/1?utm_source=fb&utm_medium=display&utm_campaign=poland_183%20%D7%A7%D7%9E%D7%A4%D7%99%D7%99%D7%9F&utm_content=Facebook_Desktop_Feed&fbclid=IwAR3262QkKPBK2JwSSLiS-K5m07w4hO4-aq2Oaw7OkD1dUZGRzmlFaFGMQ-w 
/**
 * Route guard for pages only the site admin may open.
 *
 * NOTE: the `meta: { requiresAuth, requiresManager }` flags declared on routes
 * throughout this file are NOT enforced -- nothing in this app reads `to.meta`,
 * so they block nobody. A page that must actually be restricted therefore needs
 * a real `beforeEnter` like this one.
 *
 * `userId === 1` matches how the rest of the GUI decides who is an admin
 * (NavBar.isAdmin). It is a convenience, not the security boundary: the
 * /api/admin/whatsapp_conversation* endpoints answer 403 to anyone who is not
 * the owner of ride 1, so this guard hides the page while the server refuses
 * the data.
 */
function adminOnly( to, from, next ) {
  if ( store.getters.userId === 1 ) {
    return next();
  }
  return next( '/' );
}

router.beforeEach((to, from, next) => {
  // Check for language parameter in URL query (lang or language)
  // This should happen early, before any page loads, so language is set before login messages and ride information
  if (to.query.lang || to.query.language) {
    const langParam = to.query.lang || to.query.language;
    try {
      // Normalize the language parameter (accept 'en', 'english', 'he', 'hebrew')
      let normalizedLang = langParam.toLowerCase();
      if (normalizedLang === 'english' || normalizedLang === 'en') {
        normalizedLang = 'en';
      } else if (normalizedLang === 'hebrew' || normalizedLang === 'he') {
        normalizedLang = 'he';
      }
      
      // Only set if it's a supported language
      if (normalizedLang === 'en' || normalizedLang === 'he') {
        store.dispatch('language/setLanguage', normalizedLang);
      }
    } catch (error) {
      console.warn('Failed to set language from URL parameter:', error);
    }
  }
  
  // Redirect root to /welcome-ride-managers for tripplannerit.com users
  if (to.path === '/') {
    const hostname = String(window.location.hostname || '').toLowerCase();
    const isTripplannerit = hostname === 'tripplannerit.com' || hostname === 'www.tripplannerit.com';
    const isEnglish = isTripplannerit ||
      store.getters['language/isEnglish'] ||
      (to.query.lang || to.query.language || '').toLowerCase().startsWith('en');
    if (isEnglish) {
      return next({ path: '/welcome-ride-managers', query: to.query });
    }
  }

  try{
    store.commit('setLabel',to.query);
  } catch ( error ){
    console.error('An error occurred:', error);
  }
  const loadNewCssPageNames = [ 'addImages',
                                'addImagesToThTrip',
                                'addAttractionFromImage',
                                'AddAccommodationsImage',
                                'AddAccommodationsImageToThTrip',
                                'AddAccommodationFromImage',
                                'ride information',
                                'ride extra information',
                                'assign to ride with key',
                                'assign to ride',
                                'assign to ride with consulting',
                                'private page landing',
                                'search ride',
                                'ride access key information',
                                'generate one ride access key',
                                'ride mnager attraction',
                                'admin_categories',
                                config.config.ROUTES_URL_NAMES.searchRideByName,
                              ];
  const movingFromTheSameCssPageType = 
  ((loadNewCssPageNames.includes(to.name)&&
    loadNewCssPageNames.includes(from.name))||
    (!loadNewCssPageNames.includes(to.name)&&
    !loadNewCssPageNames.includes(from.name)&&
    from.name!=null));

  if ( !movingFromTheSameCssPageType ) {
    if (loadNewCssPageNames.includes(to.name)) {
      loadCSS('/addTripByImages.css');
      // Remove `general.css` and `queries.css` if previously loaded
      removeCSS('/general.css');
      removeCSS('/queries.css');
    } else {
      loadCSS('/general.css');
      loadCSS('/queries.css');
      // Remove `addTripByImages.css` if previously loaded
      removeCSS('/addTripByImages.css');
    }
  }
  next();
});

function loadCSS(href) {
  // Check if the CSS file is already loaded
  if (!document.querySelector(`link[href="${href}"]`)) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }
}

function removeCSS(href) {
  // Find and remove the CSS file if it exists
  const link = document.querySelector(`link[href="${href}"]`);
  if (link) {
    document.head.removeChild(link);
  }
}

// import VueGtag from 'vue-gtag'

// Vue.use(VueGtag, {
//   config: { id: config.GOOGLE_ANALITICS_KEY }
// });


// Vue.use(VueAnalytics, {
//   id: config.config.GOOGLE_ANALITICS_KEY,
//   router
// });

// we are using 3.47 becose at 3.48 we have a bug that at  the sumary ride map we are not fit the ,ap to the bounds!!! 
// Google Maps `language` is script-load-time only, so we resolve it before VueGoogleMaps is initialized.
const resolveGoogleMapsLanguage = () => {
  const resolveDomainDefaultLanguage = () => {
    try {
      const hostname = String(window.location.hostname || '').toLowerCase();
      return hostname === 'tripplannerit.com' || hostname === 'www.tripplannerit.com' ? 'en' : 'he';
    } catch (e) {
      return 'he';
    }
  };

  const normalizeAppLanguage = (value) => {
    if (!value) return null;
    const normalized = String(value).toLowerCase();
    if (normalized === 'en' || normalized === 'english') return 'en';
    if (normalized === 'he' || normalized === 'hebrew' || normalized === 'iw') return 'he';
    return null;
  };

  // Priority 1: explicit deep-link language (`?lang=en` / `?lang=he`)
  let languageFromUrl = null;
  try {
    const params = new URLSearchParams(window.location.search);
    languageFromUrl = normalizeAppLanguage(params.get('lang'));
  } catch (e) {
    languageFromUrl = null;
  }

  // Priority 2: persisted user/app language from previous sessions
  let selectedAppLanguage = null;
  try {
    selectedAppLanguage = normalizeAppLanguage(localStorage.getItem('selectedLanguage'));
    if (languageFromUrl) {
      // Keep app language aligned with the deep-link for this render and next visits.
      localStorage.setItem('selectedLanguage', languageFromUrl);
      selectedAppLanguage = languageFromUrl;
    }
  } catch (e) {
    selectedAppLanguage = languageFromUrl || null;
  }

  // Priority 3: domain-aware fallback when nothing is available.
  // Vuex uses `he`/`en`; Google Maps expects `iw` for Hebrew.
  const fallbackLanguage = resolveDomainDefaultLanguage();
  return (selectedAppLanguage || fallbackLanguage) === 'en' ? 'en' : 'iw';
};

const googleMapsLanguage = resolveGoogleMapsLanguage();
try {
  sessionStorage.setItem('googleMapsLanguageLoaded', googleMapsLanguage);
} catch (e) {
  // If sessionStorage is blocked, we still proceed; reload-sync will be best-effort.
}
Vue.use(VueGoogleMaps, {
  load: {
    key: config.config.GOOGLE_API_KEY,
    libraries: "places", // necessary for places input,
    language: googleMapsLanguage,
    v: '3.47'
  }
});
new Vue({
  router,
  store,
  render: h => h(App),

  created () {
    // Load language preference from storage (but don't let it interfere with offline mode)
    try {
      this.$store.dispatch('language/loadLanguageFromStorage');
      // The loadLanguageFromStorage action will set the document direction
    } catch (error) {
      console.warn('Failed to load language from storage:', error);
      // Set default direction if loading fails
      const defaultLanguage = this.$store.getters['language/getCurrentLanguage'];
      const isHebrew = defaultLanguage === 'he';
      if (typeof document !== 'undefined') {
        document.documentElement.setAttribute('dir', isHebrew ? 'rtl' : 'ltr');
        document.documentElement.setAttribute('lang', isHebrew ? 'he' : 'en');
      }
    }
    
    // Only initialize Firebase if not in offline mode
    if (window.location.pathname !== '/offline_ride_view') {
      firebase.initializeApp(firebaseConfig)
      firebase.auth().useDeviceLanguage()
    }
  },

}).$mount('#app');
